import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { User } from '../models/interfaces/user.interface';
import { environment } from '../../config/environments/environment';
import { UserDetailsDto } from '../models/dto/user-details.dto';
import { UserNotification } from '../models/interfaces/user-notification.interface';
import { UserActivationDto } from '../models/dto/user-activation.dto';
import { PageDto } from '../models/dto/arrival/page.dto';
import { UserParamsDto } from '../models/dto/user-params.dto';

@Injectable()
export class UsersService {
  private readonly users_path = 'users';

  constructor(private readonly http: HttpClient) {}

  /**
   * @deprecated
   * Não está sendo usado ...
   */
  getAll(): Observable<User[]> {
    const users = this.http.get<User[]>(
      `${environment.api.baseUrl}/${this.users_path}`
    );
    return users;
  }

  getAllV2(params?: UserParamsDto): Observable<PageDto<UserActivationDto>> {
    const url = `${environment.api.baseUrl}/${this.users_path}/v2`;
    return this.http.get<PageDto<UserActivationDto>>(url, {
      params: this.buildHttpParams(params),
    });
  }

  getEmployees(params?: UserParamsDto): Observable<User[]> {
    return this.http
      .get<User[]>(`${environment.api.baseUrl}/${this.users_path}/employees`, {
        params: this.buildHttpParams(params),
      })
      .pipe((response) => response);
  }

  getById(id: string): Observable<User> {
    return this.http.get<User>(`${environment.api.baseUrl}/users/${id}`);
  }

  getByName(params: UserParamsDto): Observable<User[]> {
    return this.http.get<User[]>(
      `${environment.api.baseUrl}/${this.users_path}/v2/q`,
      { params: this.buildHttpParams(params) }
    );
  }

  getDetails(id: string): Observable<UserDetailsDto> {
    return this.http.get<UserDetailsDto>(
      `${environment.api.baseUrl}/users/details/${id}`
    );
  }

  getDetailsByRoomMembers(ids: string): Observable<UserDetailsDto> {
    return this.http.get<UserDetailsDto>(
      `${environment.api.baseUrl}/users/q/roommembers`,
      {
        params: { ids },
      }
    );
  }

  create(user: User): Observable<User> {
    return this.http.post<User>(
      `${environment.api.baseUrl}/${this.users_path}/signup`,
      user
    );
  }

  update(user: User): Observable<User> {
    return this.http.put<User>(
      `${environment.api.baseUrl}/${this.users_path}/${user.id}`,
      user
    );
  }

  /**
   * @deprecated
   * Não está sendo usado ...
   */
  getAllUsersWithActivationStatus(): Observable<UserActivationDto[]> {
    return this.http.get<UserActivationDto[]>(
      `${environment.api.baseUrl}/${this.users_path}/active`
    );
  }

  addUserNotificationV2(
    id: string,
    userNotification: UserNotification
  ): Observable<string> {
    return this.http.patch(
      `${environment.api.baseUrl}/${this.users_path}/${id}/add-user-notification`,
      userNotification,
      { responseType: 'text' }
    );
  }

  removeUserNotificationV2(
    id: string,
    userNotification: UserNotification
  ): Observable<string> {
    return this.http.patch(
      `${environment.api.baseUrl}/${this.users_path}/${id}/remove-user-notification`,
      userNotification,
      { responseType: 'text' }
    );
  }

  enable(id: string): Observable<any> {
    return this.http.patch(
      `${environment.api.baseUrl}/${this.users_path}/${id}/enable`,
      null
    );
  }

  disable(id: string): Observable<any> {
    return this.http.patch(
      `${environment.api.baseUrl}/${this.users_path}/${id}/disable`,
      null
    );
  }

  private buildHttpParams(params?: UserParamsDto): any {
    const httpParams: any = {};

    if (params?.idsSchool) {
      httpParams.idsSchool = params.idsSchool;
    }

    if (params?.name) {
      httpParams.name = params.name;
    }

    if (params?.idsProfiles) {
      httpParams.idsProfiles = params.idsProfiles;
    }

    if (params?.limit) {
      httpParams.limit = params.limit;
    }

    if (params?.page) {
      httpParams.page = params.page;
    }

    if (params?.idsClassRooms) {
      httpParams.idsClassRooms = params.idsClassRooms;
    }

    if (params?.active !== undefined && params?.active !== null) {
      httpParams.active = params.active;
    }

    return httpParams;
  }
}
